module.exports = __webpack_public_path__ + "static/media/GAME_Pending.52ba23a7.svg";